import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { LAST_INFO_MODAL_SHOWN_KEY } from '@app/shared/constants';
import { AbsencesDaysService } from '@app/time-sheet/service/absences-days-service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TIMESHEET_MODAL_DATA } from './timesheet-modal-data.token';

@Component({
  selector: 'abc-timesheet-info-modal',
  imports: [DatePipe],
  templateUrl: 'timesheet-info-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimesheetInfoModal {
  absencesDaysService = inject(AbsencesDaysService);
  modalRef = inject(NgbActiveModal);
  private data = inject(TIMESHEET_MODAL_DATA);
  year = signal(this.data.year);
  month = signal(this.data.month);

  absenceDays = this.absencesDaysService.absenceDays;

  constructor() {
    effect(() => {
      this.getAbsences();
    });
  }

  getAbsences() {
    if (this.year() && this.month()) {
      this.absencesDaysService.refreshVacationDays(this.year(), this.month());
    }
  }

  closeModal() {
    const now = Date.now();
    localStorage.setItem(LAST_INFO_MODAL_SHOWN_KEY, now.toString());
    this.modalRef.close();
  }
}
